import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const Description = ({ governate, year, lang }) => {
  return (
    <>
      {year && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en' ? 'Year of Operation' : 'سنة التشغيل'}
          </div>
          <div className="value">{year}</div>
        </ResourceDetailsBlock>
      )}
      <ResourceDetailsBlock>
        <span className="label">
          {lang === 'en' ? 'Governorate' : 'المحافظة'}
        </span>
        <span className="value">{governate[lang]}</span>
      </ResourceDetailsBlock>
    </>
  )
}

Description.propTypes = {
  governate: PropTypes.object,
  year: PropTypes.string,
  lang: PropTypes.string
}

export default Description
